import React, { useState, useEffect, useCallback } from 'react';
import './AdInterstitial.css';

/**
 * インタースティシャル広告コンポーネント
 *
 * ゲーム終了時などの自然な切り替えポイントで全画面広告を表示
 * 一定時間後にスキップ可能
 */

const ADSENSE_CLIENT = import.meta.env.VITE_ADSENSE_CLIENT || '';
const ADSENSE_ENABLED = import.meta.env.VITE_ADSENSE_ENABLED === 'true';

// スキップ可能になるまでの秒数
const SKIP_DELAY_SECONDS = 5;

function AdInterstitial({
  slot,
  isVisible,
  onClose,
  onAdLoaded,
}) {
  // TODO: ドメイン審査通過後に削除
  return null;

  const [canSkip, setCanSkip] = useState(false);
  const [countdown, setCountdown] = useState(SKIP_DELAY_SECONDS);
  const [adError, setAdError] = useState(false);
  const isAdFree = false; // TODO: useSubscription() から取得

  // カウントダウン処理
  useEffect(() => {
    if (!isVisible) {
      setCanSkip(false);
      setCountdown(SKIP_DELAY_SECONDS);
      return;
    }

    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          setCanSkip(true);
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isVisible]);

  // AdSenseの広告をプッシュ
  useEffect(() => {
    if (!isVisible || !ADSENSE_ENABLED || !ADSENSE_CLIENT || isAdFree) return;

    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      onAdLoaded?.();
    } catch (e) {
      console.error('AdSense interstitial error:', e);
      setAdError(true);
    }
  }, [isVisible, isAdFree, onAdLoaded]);

  const handleClose = useCallback(() => {
    if (canSkip || adError) {
      onClose?.();
    }
  }, [canSkip, adError, onClose]);

  // 広告非表示ユーザーまたは非表示状態
  if (!isVisible || isAdFree) return null;

  // AdSense未設定またはエラー時は短いプレースホルダー表示後に自動クローズ
  if (!ADSENSE_ENABLED || !ADSENSE_CLIENT || adError) {
    return (
      <div className="ad-interstitial-overlay" onClick={handleClose}>
        <div className="ad-interstitial-container">
          <div className="ad-interstitial-placeholder">
            <span className="ad-placeholder-text">広告</span>
          </div>
          <button
            className="ad-interstitial-skip"
            onClick={handleClose}
          >
            スキップ
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="ad-interstitial-overlay">
      <div className="ad-interstitial-container">
        <div className="ad-interstitial-header">
          <span className="ad-label">広告</span>
          {canSkip ? (
            <button
              className="ad-interstitial-skip"
              onClick={handleClose}
            >
              スキップ
            </button>
          ) : (
            <span className="ad-interstitial-countdown">
              {countdown}秒後にスキップ可能
            </span>
          )}
        </div>
        <div className="ad-interstitial-content">
          <ins
            className="adsbygoogle"
            style={{ display: 'block', width: '100%', height: '250px' }}
            data-ad-client={ADSENSE_CLIENT}
            data-ad-slot={slot}
            data-ad-format="rectangle"
          />
        </div>
      </div>
    </div>
  );
}

export default AdInterstitial;
